function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.0052 0 0 1.0172 4.9905 .40774)",
  strokeMiterlimit: 8
}, React.createElement("rect", {
  x: 14.529,
  y: 10.02,
  width: 39.791,
  height: 24.48,
  fill: "#fff",
  stroke: "#002060",
  strokeWidth: 0.9889
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m19.811 28.905 9.6696-3.7305 9.8069 2.7978 9.3984-7.4606",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.9889
}), React.createElement("g", {
  className: "icon-secondary",
  transform: "matrix(.35213 0 0 .34972 .97183 .40246)",
  fill: "#adb9ca",
  fillRule: "evenodd",
  strokeWidth: 2.818
}, React.createElement("path", {
  d: "m104.5 79c0-1.933 1.57-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.567-3.5-3.5z"
}), React.createElement("path", {
  d: "m49.5 80.903c0-1.8792 1.57-3.4029 3.5-3.4029s3.5 1.5236 3.5 3.4029-1.57 3.4029-3.5 3.4029-3.5-1.5236-3.5-3.4029z"
}), React.createElement("path", {
  d: "m76.5 70.5c0-2.209 1.79-4 4-4s4 1.791 4 4-1.79 4-4 4-4-1.791-4-4z"
})), React.createElement("path", {
  className: "icon-primary",
  d: "m47.277 20.336c0-0.67601 0.53623-1.224 1.1983-1.224s1.1983 0.54801 1.1983 1.224-0.53623 1.224-1.1983 1.224-1.1983-0.54801-1.1983-1.224z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  strokeWidth: 0.9889
}), React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.35213 0 0 .34972 -2.9157 -16.544)",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 2.818
}, React.createElement("path", {
  d: "m115.54 127.46c0-1.933 1.57-3.5 3.5-3.5s3.5 1.567 3.5 3.5-1.57 3.5-3.5 3.5-3.5-1.567-3.5-3.5z"
}), React.createElement("path", {
  d: "m60.54 129.36c0-1.8792 1.57-3.4029 3.5-3.4029s3.5 1.5236 3.5 3.4029c0 1.8792-1.57 3.4029-3.5 3.4029s-3.5-1.5236-3.5-3.4029z"
}), React.createElement("path", {
  d: "m87.54 118.96c0-2.209 1.79-4 4-4s4 1.791 4 4-1.79 4-4 4-4-1.791-4-4z"
}), React.createElement("path", {
  d: "m142.54 105.46c0-1.933 1.5228-3.5 3.4029-3.5s3.4029 1.567 3.4029 3.5-1.5228 3.5-3.4029 3.5-3.4029-1.567-3.4029-3.5z"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m5.2978 7.391c0-1.9989 1.6314-3.6194 3.6446-3.6194h17.008c2.0132 0 3.6446 1.6204 3.6446 3.6194v14.477c0 1.9989-1.6314 3.6194-3.6446 3.6194h-17.008c-2.0132 0-3.6446-1.6204-3.6446-3.6194z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m8.9944 3.7127h17.022c2.0097 0 3.6377 1.5815 3.6377 3.5328v4.0506h-24.297v-4.0506c0-1.9514 1.6279-3.5328 3.6377-3.5328z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m8.9354 3.7716h17.022c2.0097 0 3.6377 1.6122 3.6377 3.6015v4.1293h-24.297v-4.1293c0-1.9893 1.6279-3.6015 3.6377-3.6015z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.49723 4.2784c0-2.0258 1.6195-3.668 3.6181-3.668h16.884c1.9986 0 3.6181 1.6422 3.6181 3.668v14.672c0 2.0258-1.6195 3.668-3.6181 3.668h-16.884c-1.9986 0-3.6181-1.6422-3.6181-3.668z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m4.1349 0.6104h17.022c2.0097 0 3.6377 1.6535 3.6377 3.6935v4.2347h-24.297v-4.2347c0-2.0399 1.6279-3.6935 3.6377-3.6935z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 5.3567,
  y: 11.296,
  width: 3.1239,
  height: 2.2914,
  fill: "#adb9ca"
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 5.5335,
  y: 16.458,
  width: 2.8882,
  height: 1.9238,
  fill: "#adb9ca"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}, React.createElement("path", {
  d: "m4.5971 3.9951c0-0.28118 0.21258-0.50926 0.47123-0.50926h15.001c0.25864 0 0.47123 0.22808 0.47123 0.50926v2.0378c0 0.28118-0.21258 0.50926-0.47123 0.50926h-15.001c-0.25864 0-0.47123-0.22808-0.47123-0.50926z",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m4.1084 0.6104h16.898c1.9951 0 3.6112 1.6535 3.6112 3.6935v4.2347h-24.121v-4.2347c0-2.0399 1.6161-3.6935 3.6112-3.6935z",
  fill: "none"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  stroke: "#002060"
}, React.createElement("path", {
  d: "m11.952 12.519h8.452",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "m11.952 17.504h8.452",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeMiterlimit: 8
}), React.createElement("rect", {
  x: 5.5629,
  y: 11.502,
  width: 2.8293,
  height: 2.1006,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("rect", {
  x: 5.5335,
  y: 16.546,
  width: 2.8882,
  height: 1.9238,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));
var SvgMenuPulse = function SvgMenuPulse(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    viewBox: "0 0 60 36",
    overflow: "hidden",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuPulse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-pulse.eba726ae.svg";
export { ForwardRef as ReactComponent };